import { defineWidgetCore } from "../../widgetDefinition";
import type { AiInsightsComponentSpec } from "../../Processing/types";
import { renderAiInsights } from "../../PDF/renderers/aiInsightsPdfRenderer";

export const aiInsightsCore = defineWidgetCore<AiInsightsComponentSpec>({
  process(spec) {
    return { type: "ai_insights", spec };
  },
  pdf: {
    buildSnapshot({ aiParts }) {
      return { type: "ai_insights", parts: aiParts ?? [] };
    },
    render({ snapshot, rect, scale }) {
      if (snapshot.type !== "ai_insights") return null;
      return renderAiInsights(snapshot, rect, scale);
    },
  },
});
